import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { DocumentResponse } from '../types/api';
import { documentService } from '../services/documentService';

interface DataContextType {
  documents: DocumentResponse[];
  isLoadingDocuments: boolean;
  refreshDocuments: () => Promise<void>;
}

const DataContext = createContext<DataContextType | undefined>(undefined);

interface DataProviderProps {
  children: ReactNode;
}

export const DataProvider: React.FC<DataProviderProps> = ({ children }) => {
  const [documents, setDocuments] = useState<DocumentResponse[]>([]);
  const [isLoadingDocuments, setIsLoadingDocuments] = useState(true);

  // Données chargées depuis l'API backend

  // Charger les documents
  const loadDocuments = async () => {
    try {
      setIsLoadingDocuments(true);
      const page = await documentService.getAllDocuments(0, 10000);
      setDocuments(page.content);
    } catch (error) {
      console.error('Erreur lors du chargement des documents:', error);
    } finally {
      setIsLoadingDocuments(false);
    }
  };

  // Rafraîchir les documents
  const refreshDocuments = async () => {
    await loadDocuments();
  };

  // Charger les données au montage du composant
  useEffect(() => {
    loadDocuments();
  }, []);

  const value: DataContextType = {
    documents,
    isLoadingDocuments,
    refreshDocuments
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};